<template>
    <BreadCrumb PageTitle=" Liste des groupes de taxe" />
  <ListeGroupeDeTaxe/>
</template>

<script lang="ts">
  import { defineComponent } from "vue";

  import BreadCrumb from "../../components/Common/BreadCrumb.vue";
  import ListeGroupeDeTaxe from "@/components/GroupeDeTaxe/ListeGroupeDeTaxe.vue";

  export default defineComponent({
    name: "ListeGroupeDeTaxePage",
    components: {
      BreadCrumb ,
      ListeGroupeDeTaxe,
    },
  });
</script>